module.exports = __webpack_public_path__ + "img/zoom-out.711051d7.svg";